var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-12"},[_c('header-logo',{staticStyle:{"cursor":"pointer"},attrs:{"to":{ name: 'login' }}}),_c('h1',[_vm._v("Sorry!")]),_c('p',[_vm._v("We're sorry, it appears you have an invalid link.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }